import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationModels } from '@wz-models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class SettingApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'AdministrationSetting');
  }
}
